export default angular.module('usefulDirectives', [])
	.directive('sameAs', function() {
		return {
			require: 'ngModel',
			link: function(scope, elem, attrs, ngModel) {
				ngModel.$parsers.unshift(validate);

				// Force-trigger the parsing pipeline.
				scope.$watch(attrs.sameAs, function() {
					validate(ngModel.$viewValue);
				});

				function validate(value) {
					var isValid = scope.$eval(attrs.sameAs) == value;

					ngModel.$setValidity('same-as', isValid);

					return isValid ? value : undefined;
				}
			}
		};
	}).directive('ngEnter', function() {
		return function(scope, element, attrs) {
			element.bind("keydown keypress", function(event) {
				if (event.which === 13) {
					scope.$apply(function() {
						scope.$eval(attrs.ngEnter);
					});

					event.preventDefault();
				}
			});
		};
	})
	.directive('notImplemented', function(Notification) {
		return function(scope, elem, attr) {
			elem.bind('click', (e) => {
				e.preventDefault();

				Notification.warning('Dosud není hotové :-(');
			});
		};
	})
	.directive('focusOn', function() {
		return function(scope, elem, attr) {
			scope.$on('focusOn', function(e, name) {
				if (name === attr.focusOn) {
					elem[0].focus();
				}
			});
		};
	}).factory('focus', function($rootScope, $timeout) {
		return function(name) {
			$timeout(function() {
				$rootScope.$broadcast('focusOn', name);
			});
		}
	}).directive('vin', function() {
		return {
			require: 'ngModel',
			link: function(scope, elm, attrs, ngModel) {
				ngModel.$parsers.unshift(validate);

				function validate(value) {
					var isValid = false;

					value = value.toUpperCase();

					if (value.indexOf('I') === -1 && value.indexOf('O') === -1 && value.indexOf('Q') === -1) {
						isValid = true;
					}

					ngModel.$setValidity('vin', isValid);
					return value;
				}
			}
		};
	}).directive('nextOnEnter', function() {
		return {
			restrict: 'A',
			link: function($scope, selem) {
				selem.bind('keydown', function(e) {
					var code = e.keyCode || e.which;
					if (code === 13) {
						e.preventDefault();
						var pageElems = document.querySelectorAll('input, select, textarea');
						var elem = e.srcElement;
						var focusNext = false;
						var len = pageElems.length;

						for (var i = 0; i < len; i++) {
							var pe = pageElems[i];
							if (focusNext) {
								if (pe.style.display !== 'none') {
									pe.focus();
									break;
								}
							} else if (pe === e.srcElement) {
								focusNext = true;
							}
						}
					}
				});
			}
		}
	}).name;



// WEBPACK FOOTER //
// build/helpers/usefulDirectives.js